export const X_AUTH_TOKEN = process.env.REACT_APP_X_AUTH_TOKEN;
export const API_ENDPOINT = 'https://fit.kleep.ai/';
export const BUCKET_NAME = process.env.REACT_APP_BUCKET_NAME;